import {get, patch} from './http';

export type Role = 'analyst' | 'analyst_admin' | 'admin';

export type UserProfile = {
  id: string;
  email: string;
  display_name: string;
  // Empty when Auth0 has assigned this user no role - see AuthService.GetOrProvisionUserWithVerticalsAsync.
  role: Role | '';
  allowed_verticals: string[] | null; // Null means access to all verticals
  skip_p0_approval: boolean;
  // Derived from qc_required_verticals: true when this analyst is gated on at least one vertical.
  requires_qc_review: boolean;
  // Per-vertical QC gate: null = every vertical requires QC, [] = none, a subset = only those.
  qc_required_verticals: string[] | null;
  // The Auth0 subject switch targeting matches on; null until the user has signed in.
  auth0_subject: string | null;
};

export const usersApi = {
  me: async () => get<UserProfile>('/users/me'),

  mySwitches: async () => get<{switches: Record<string, boolean>}>('/users/me/switches'),

  listAll: async () => get<UserProfile[]>('/admin/users'),

  updateVerticals: async (id: string, verticals: string[] | null) =>
    patch<{allowed_verticals: string[] | null}, UserProfile>(`/admin/users/${id}/verticals`, {
      allowed_verticals: verticals
    }),

  updateSkipP0Approval: async (id: string, skipP0Approval: boolean) =>
    patch<{skip_p0_approval: boolean}, UserProfile>(`/admin/users/${id}/skip-p0-approval`, {
      skip_p0_approval: skipP0Approval
    }),

  updateQcRequiredVerticals: async (id: string, verticals: string[] | null) =>
    patch<{qc_required_verticals: string[] | null}, UserProfile>(
      `/admin/users/${id}/qc-required-verticals`,
      {
        qc_required_verticals: verticals
      }
    )
};
